import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'

import HeroBanner from '../components/hero-banner'
import Map from '../components/map'
import Enquiry from '../components/enquiry'

const ContactPage = () => (
  <div>
    <Helmet
      title="Get in touch if you like my work, and interested in working together."
      meta={[
        {
          name: 'description',
          content:
            'Like my work, and interested in working together? Get in touch so we can discuss your requirements.',
        },
      ]}
    />
    <HeroBanner heroId="phone-hero" nextId="contact">
      <div className="heading">
        <h2>Contact me</h2>
      </div>
    </HeroBanner>
    <div id="contact" className="section white">
      <div className="wrapper">
        <div className="columnar">
          <header className="story">
            <h2>CONTACT</h2>
            <p>
              Neil Rudd<br />
              7 Steward Close<br />
              Wymondham<br />
              Norfolk<br />
              NR18 0EZ
            </p>
            <h3>EMAIL</h3>
            <p>
              <a href="mailto:hello@neilrudd.co.uk">hello@neilrudd.co.uk</a>
            </p>
            <h3>Telephone</h3>
            <p>01953 600 859</p>
          </header>
          <div className="content">
            <Enquiry />
          </div>
        </div>
      </div>
    </div>
    <div className="section wevet white">
      <div className="wrapper">
        <div className="columnar story">
          <header>
            <h1>Why Norfolk</h1>
          </header>
          <div className="article">
            <p>
              Boasting beautiful landscapes and historic market towns Norfolk is
              a great place to live and work and unlike its portrayal in the
              media, it is very far from being a sleepy backwater. Norfolk has a
              strong creative and digital presence with many leading marketing
              agencies having their offices in Norwich or the surrounding area
              and with a fast direct train line to London we are not far away
              from the hustle and bustle of the capital.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div className="wevet-bar white">
      <div className="wrapper">
        <Map />
      </div>
    </div>
    <div className="section white">
      <div className="wrapper center story">
        <h3>Let's work together</h3>
        <p>
          Like my work, and interested in working together? Get in touch so we
          can discuss your requirements.
        </p>
        <p>
          I'm currently booking in projects to commence from late Sept 2018.
        </p>
      </div>
    </div>
  </div>
)

export default ContactPage



// WEBPACK FOOTER //
// ./src/pages/contact-me.js